/**
 *
 * SeeAllLink
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import ClassNames from 'classnames';
// import ArrowDown from './images/arrow-down.svg';
import ArrowRight from './images/chevron_right.svg';

const styles = theme => ({
  icon: {
    margin: '0 15px 3px',
    color: theme.palette.primary.main,
  },
  link: {
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('600')]: {
      justifyContent: 'center',
    },
  },
  justifyLeft: {
    justifyContent: 'flex-start',
  },
  mobile: {
    justifyContent: 'center',
    marginTop: 10,
    [theme.breakpoints.down('600')]: {
      width: 261,
    },
  },
  bordered: {
    border: '1px solid #E9ECED',
    padding: '10px 15px',
    display: 'flex',
    borderRadius: 2,
  },
  linkText: {
    display: 'flex',
    alignItems: 'center',
    textTransform: 'none',
    ...theme.typography.overline,
  },
  rightIcon: {
    marginLeft: 10,
    marginBottom: 2,
  },
});

function SeeAllLink({
  link,
  hide,
  align = 'right',
  label = 'View All',
  isMobile,
  classes,
  clickHandler,
  bordered,
  position,
}) {
  if (hide) return null;
  return (
    <Link
      to={`/${link}`}
      className={ClassNames(
        classes.link,
        bordered ? classes.bordered : undefined,
        isMobile ? classes.mobile : undefined,
        position === 'left' ? classes.justifyLeft : undefined,
      )}
      onClick={clickHandler}
    >
      <Typography
        color="textSecondary"
        align={align}
        className={classes.linkText}
      >
        {label}
        {/* {isMobile && (
          <img src={ArrowDown} alt="Arrow Icon" className={classes.icon} />
        )} */}
        <img src={ArrowRight} alt="Arrow Icon" className={classes.rightIcon} />
      </Typography>
    </Link>
  );
}

SeeAllLink.propTypes = {
  link: PropTypes.string,
  hide: PropTypes.bool,
  align: PropTypes.string,
  label: PropTypes.string,
  isMobile: PropTypes.bool,
  classes: PropTypes.object,
  clickHandler: PropTypes.func,
  bordered: PropTypes.bool,
  position: PropTypes.string,
};

SeeAllLink.defaultProps = {
  isMobile: false,
  bordered: false,
};

export default withStyles(styles)(SeeAllLink);
